import * as fromDatatype from '../../../datatype-library';

export class AccessKeyPostRequestModel {
  label: string;
  type: string;
  validDateEnd: fromDatatype.TimestampTzDatatypeInterface;
}
